import { fg } from '@confluence/feature-gating';
import { cfetch } from '@confluence/network';
import {
	superbatchCSSRecorder,
	superbatchJSRecorder,
	ssrPrepareErrorsClient,
} from '@confluence/ssr-utilities';

function convertResourceToScriptTags(resource: {
	url: string;
	resourceType: 'CSS' | 'JAVASCRIPT';
	ieOnly: boolean;
	key: string;
	batchType: string;
}) {
	const nonce = window.__SSR_NONCE_VALUE__;
	if (resource.resourceType === 'CSS') {
		return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}" data-key="${resource.key}" data-batch-type="${resource.batchType}"${resource.ieOnly ? ' data-ie-only="true"' : ''} />`;
	} else if (resource.resourceType === 'JAVASCRIPT') {
		return `<script nonce="${nonce}" src="${resource.url}" data-key="${resource.key}" data-batch-type="${resource.batchType}"${resource.ieOnly ? ' data-ie-only="true"' : ''}></script>`;
	}
	return '';
}

export const preloadConnectWebResources = async () => {
	if (
		!(
			fg('content_early_connect_iframe_initialization') ||
			fg('content_early_connect_iframe_initialization_part_2')
		)
	) {
		return;
	}

	try {
		const response = await cfetch('/wiki/rest/webResources/1.0/resources', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				r: [
					'confluence.web.resources:querystring',
					'confluence.web.resources:navigator-context',
					'com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5',
				],
				c: [],
				xc: ['_super'],
				xr: ['com.atlassian.plugins.jquery:jquery', 'com.atlassian.plugins.jquery:jquery-migrate'],
			}),
		});

		if (!response.ok) {
			throw new Error(`Failed to preload web resources: ${response.status}`);
		}

		const data = await response.json();

		superbatchJSRecorder.addConnectResource(
			data?.resources
				?.filter((resource) => resource.resourceType === 'JAVASCRIPT')
				?.map((resource) => convertResourceToScriptTags(resource))
				.join('\n'),
		);

		superbatchCSSRecorder.addConnectResource(
			data?.resources
				?.filter((resource) => resource.resourceType === 'CSS')
				?.map((resource) => convertResourceToScriptTags(resource))
				.join('\n'),
		);
	} catch (error) {
		ssrPrepareErrorsClient.submitError(
			new Error(`Unable to preload connect web resources: ${error.message}`),
		);
	}
};
